var render = function render(){var _vm=this,_c=_vm._self._c;return _c('insurance-company-sex-analyze-bar-chart')
}
var staticRenderFns = []

export { render, staticRenderFns }